import type { DockInfo, DockState } from '@shared/types/display.ts'

export const DOCK_SNAPSHOT_TOPIC = 'dock:snapshot'

export interface DockSnapshot {
  revision: number
  info: DockInfo | null
  state: DockState
}

export const EMPTY_DOCK_STATE: DockState = {
  liveBounds: null,
  visibleBounds: null,
  isVisible: false,
  source: 'none',
  position: undefined,
  thickness: 0,
  autoHide: false,
}

export const EMPTY_DOCK_SNAPSHOT: DockSnapshot = {
  revision: 0,
  info: null,
  state: EMPTY_DOCK_STATE,
}
